// extracted by mini-css-extract-plugin
export default {"danger":"zwX9zK915kCDICrVPT7a","dealerPhone":"tQF9Om4uC8WktorI3KRq","dealerEmail":"dLGUMlRAJi8xcSV9T622","placeHolderShimmer":"H9U72wYljeZKUHVXY5Dr"};